// Neon confirm/prompt dialogs — Promise-based replacements for native confirm()/prompt().
// Usage: if (!await uiConfirm('msg')) return;   const v = await uiPrompt('msg', '0');
let _el = null, _input = null, _resolve = null, _isPrompt = false;

function _build() {
  if (_el) return;
  _el = document.createElement('div');
  _el.className = 'ui-dlg';
  _el.innerHTML =
    '<div class="ui-dlg-card">' +
      '<div class="ui-dlg-title" id="uiDlgTitle"></div>' +
      '<div class="ui-dlg-msg" id="uiDlgMsg"></div>' +
      '<input class="ui-dlg-input" id="uiDlgInput" style="display:none">' +
      '<div class="ui-dlg-acts">' +
        '<button class="btn ui-dlg-cancel" id="uiDlgCancel">Cancel</button>' +
        '<button class="btn btn-p ui-dlg-ok" id="uiDlgOk">Confirm</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(_el);
  _input = _el.querySelector('#uiDlgInput');
  _el.querySelector('#uiDlgCancel').addEventListener('click', () => _close(_isPrompt ? null : false));
  _el.querySelector('#uiDlgOk').addEventListener('click', () => _close(_isPrompt ? _input.value : true));
  _el.addEventListener('mousedown', e => { if (e.target === _el) _close(_isPrompt ? null : false); });
  document.addEventListener('keydown', e => {
    if (!_el || !_el.classList.contains('on')) return;
    if (e.key === 'Escape') _close(_isPrompt ? null : false);
    else if (e.key === 'Enter' && _isPrompt) { e.preventDefault(); _close(_input.value); }
  });
}

function _close(val) {
  if (_el) _el.classList.remove('on');
  const r = _resolve; _resolve = null;
  if (r) r(val);
}

function _open(o) {
  _build();
  _isPrompt = !!o.isPrompt;
  _el.querySelector('#uiDlgTitle').textContent = o.title || (_isPrompt ? 'Input' : 'Confirm');
  _el.querySelector('#uiDlgMsg').innerHTML = String(o.message || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\n/g, '<br>');
  const ok = _el.querySelector('#uiDlgOk');
  ok.textContent = o.okText || (_isPrompt ? 'Save' : 'Confirm');
  ok.classList.toggle('btn-d', !!o.danger);
  ok.classList.toggle('btn-p', !o.danger);
  if (_isPrompt) { _input.style.display = ''; _input.type = o.inputType || 'text'; _input.value = o.defaultVal != null ? o.defaultVal : ''; }
  else { _input.style.display = 'none'; }
  _el.classList.add('on');
  if (_isPrompt) setTimeout(() => { _input.focus(); _input.select(); }, 30);
  return new Promise(res => { _resolve = res; });
}

export function uiConfirm(message, opts) { return _open(Object.assign({}, opts, { message, isPrompt: false })); }
export function uiPrompt(message, defaultVal, opts) { return _open(Object.assign({}, opts, { message, defaultVal, isPrompt: true })); }
